module.exports = __webpack_public_path__ + "static/media/agency_banner_preview.9b94de5f.jpg";